import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ArticleOrder } from "../models/article-order";
import { CrudService } from "./crud.service";

@Injectable({ providedIn: "root" })
export class ArticleOrdersService extends CrudService<ArticleOrder, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/article_orders`);
  }

  quote(id: number, data: { approved_budget: number; quote_notes: string; billing_email: string }): Observable<{ status: string; email_sent?: boolean; message?: string }> {
    return this._http.post<{ status: string; email_sent?: boolean; message?: string }>(`${this._base}/quote/${id}`, data);
  }

  invoice(id: number, data: { billing_email: string; payment_reference: string; paypal_invoice_url?: string }): Observable<{ status: string; message?: string }> {
    return this._http.post<{ status: string; message?: string }>(`${this._base}/invoice/${id}`, data);
  }

  transition(id: number, data: { action: string; editorial_notes?: string; published_url?: string }): Observable<any> {
    return this._http.post(`${this._base}/transition/${id}`, data);
  }

  events(id: number): Observable<any[]> {
    return this._http.get<any[]>(`${this._base}/events/${id}`);
  }

  override delete(id: number): Observable<{ status: string }> {
    return this._http.delete<{ status: string }>(`${this._base}/delete/${id}`);
  }
}
